import { useLocation } from 'react-router';

import { useTranslation } from 'react-i18next';

import Constants from 'constants/index';

import { DataViewKey, useDataViewValue } from '@/atoms/data-view';
import { filtersToFilterInValues } from '@/atoms/data-view/helpers';

const useGetStatusLabels = (dataViewKey: DataViewKey) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { search } = location;
  const isCompliance = search.includes('compliancePlan');

  const { filters } = useDataViewValue(dataViewKey);

  const currentFilters = filtersToFilterInValues(filters);

  const statusLabels = !isCompliance
    ? {
        [Constants.TRAINING_PLANS.COMPLETED]: {
          translationString: t('TrainingPlans.statusOptions.completed'),
          value: currentFilters.includes(Constants.TRAINING_PLANS.COMPLETED),
        },
        [Constants.TRAINING_PLANS.NOT_COMPLETED]: {
          translationString: t('TrainingPlans.statusOptions.notCompleted'),
          value: currentFilters.includes(
            Constants.TRAINING_PLANS.NOT_COMPLETED,
          ),
        },
      }
    : {
        [Constants.LEARN_UPON_TRAINING_PLANS.COMPLETED]: {
          translationString: t('TrainingPlans.statusOptions.completed'),
          value: currentFilters.includes(
            Constants.LEARN_UPON_TRAINING_PLANS.COMPLETED,
          ),
        },
        [Constants.LEARN_UPON_TRAINING_PLANS.NOT_COMPLETED]: {
          translationString: t('TrainingPlans.statusOptions.notCompleted'),
          value: currentFilters.includes(
            Constants.LEARN_UPON_TRAINING_PLANS.NOT_COMPLETED,
          ),
        },
      };
  return statusLabels;
};

export default useGetStatusLabels;
